// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"c0f052f3","322":"4e9e3824","429":"b7c58a4b","456":"7d4dbe78","503":"52e4d5ce"}[chunkId] + ".chunk.js";
};